/**
 * Event Constants
 *
 * Re-exports from @bash/shared for backward compatibility.
 */

export { EVENTS, type EventName } from "@bash/shared";
